import React from "react";
import FirstRunOnboardingPage from "./FirstRunOnboardingPage";
import { hasCompletedFirstRunOnboarding } from "./firstRunOnboardingStorage";

export default function FirstRunOnboardingGate({
  children,
  bypass = false,
  configReady = true,
  enabled = false,
  mode = "once",
}) {
  const [completedOnce, setCompletedOnce] = React.useState(() => hasCompletedFirstRunOnboarding());
  const [completedThisSession, setCompletedThisSession] = React.useState(false);

  React.useEffect(() => {
    setCompletedOnce(hasCompletedFirstRunOnboarding());
  }, [enabled, mode]);

  if (bypass) return children;
  if (!configReady) {
    return (
      <div
        aria-label="Loading app experience"
        style={{
          minHeight: "100dvh",
          background: "#131120",
        }}
      />
    );
  }
  if (!enabled) return children;
  if (completedThisSession) return children;
  if (mode !== "always" && completedOnce) return children;

  return (
    <FirstRunOnboardingPage
      onComplete={() => {
        setCompletedOnce(true);
        setCompletedThisSession(true);
      }}
    />
  );
}
